import React from "react";
import ProgressTable from "../progress-table";
import { capitalize } from "../../helpers";

const Topics = ({ topichits, maxItems, sortKey = "n", filterKey = "topic" }) => {
    if (!topichits || topichits.length === 0) {
        return null;
    }

    const getProgressColor = (item) => {
        if (item.s === "pos" || item.sen === "pos") return "success";
        if (item.s === "neg" || item.sen === "neg") return "warning";
        return "inherit";
    };

    return (
        <ProgressTable
            data={topichits.filter((item) => item[filterKey])}
            filterKey={filterKey}
            sortKey={sortKey}
            maxItems={maxItems}
            capCase={capitalize}
            getColorFn={getProgressColor}
        />
    );
};

export default Topics;
